/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, December 7th 2021, 9:22:32 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { FormControl } from "@mui/material";
import { TagsInput } from "ui-widgets/tags/TagsInput";
import { useControlledInput } from "ui-widgets/forms";
import { TextFormInputProps } from "ui-widgets";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";
import { isEmail } from "lib/validation/validators";

type EmailTagsFormInputProps<T> = TextFormInputProps<T>;

export const EmailTagsFormInput = <T,>(props: EmailTagsFormInputProps<T>) => {
  const { useFormReturn } = useControlledInput<T>(props);

  const updateEmailValues = React.useCallback(
    (emails: string[]) => {
      useFormReturn.setValue(props.schema_field_key as any, emails as any);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.schema_field_key, useFormReturn.setValue]
  );

  return (
    <APIFormInputErrorWrapper {...props}>
      <CustomInputValidationErrorWrapper {...props}>
        <HelperTextInputWrapper helperText={props.helperText}>
          <FormControl>
            <TagsInput {...props} validator={isEmail} onValuesChange={updateEmailValues} />
          </FormControl>
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
